import React from 'react';
import PropTypes from 'prop-types';
import Dictionary from '../../../model/Dictionary';
import Constants from '../../../model/AppConfiguration';
import { Button } from 'material-ui';
import ClassNames from 'classnames';
import './TripsSwitchStyles.css';

const TripsSwitch = ({ selectedTrip, toggleTrips }) => (
  <div className='trips-switch' onClick={toggleTrips}>
    <Button className={ClassNames({ active: Constants.flights.oneWay === selectedTrip.id })}>
      {Dictionary.flights.oneWay}
    </Button>
    <Button className={ClassNames({ active: Constants.flights.roundTrip === selectedTrip.id })}>
      {Dictionary.flights.roundTrip}
    </Button>
  </div>
);

TripsSwitch.propTypes = {
  selectedTrip: PropTypes.object,
  toggleTrips: PropTypes.func,
};

export default TripsSwitch;



// WEBPACK FOOTER //
// ./src/components/flights/tripsSwitch/TripsSwitch.js